import { Ref } from "react";

import { FormattedMessage } from "react-intl";

import { CommonDefaultButtonProps } from "@atlaskit/button-next/dist/types/new-button/variants/default/types";
import Button from "@atlaskit/button-next/new";
import { CustomTriggerProps } from "@atlaskit/dropdown-menu";
import ChevronDownIcon from "@atlaskit/icon/core/chevron-down";
import OfficeBuildingIcon from "@atlaskit/icon/core/office-building";
import { Inline } from "@atlaskit/primitives-next";

import { CustomerDomainOrg } from "@/components/fastshift/src/state/types";

import { messages } from "../messages";
import { OrgSelectorItemMessage } from "../org-selector-item-message";

export const OrgSelectorDropdownButton = ({
    triggerRef,
    selectedDomainOrg,
    isLoading,
    isDisabled,
    sendOrgSelectorDropdownClickUIEvent,
    spacing = "compact",
    ...providedProps
}: CustomTriggerProps & {
    selectedDomainOrg: CustomerDomainOrg | null;
    isLoading: boolean;
    isDisabled: boolean;
    sendOrgSelectorDropdownClickUIEvent: () => void;
    spacing?: CommonDefaultButtonProps["spacing"];
}) => {
    return (
        <Button
            ref={triggerRef as Ref<HTMLButtonElement>}
            {...providedProps}
            spacing={spacing}
            isDisabled={isDisabled}
            isLoading={isLoading}
            onClick={(e) => {
                sendOrgSelectorDropdownClickUIEvent();
                providedProps.onClick?.(e);
            }}
        >
            <Inline space="space.100" alignInline="center" alignBlock="center">
                <OfficeBuildingIcon label="Org icon" />
                {selectedDomainOrg ? (
                    <OrgSelectorItemMessage org={selectedDomainOrg} />
                ) : (
                    <FormattedMessage
                        {...messages.orgSelectorDropdownNoOrgSelected}
                    />
                )}
                <ChevronDownIcon label="Chevron down icon" size="small" />
            </Inline>
        </Button>
    );
};
